//@flow
import React from 'react';
import Link from '../../../components/Link';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';

type Props = {
  item:CategoryModel,
  highlighted?:boolean,
  onClick?:() => void,
};

export default function CategoriesListItem(props:Props) {
  const url = `/products/${props.item.getUrlKey()}#category-content`;
  let cls = props.item.getUrlKey();
  if (props.highlighted) cls += ' highlighted';
  return (
    <>
      <li role="menuitem">
        <Link to={url} className={cls} onClick={props.onClick}>
          <div className="categories-list-item-name">
            {props.item.getName()}
          </div>
          {props.highlighted &&
          <div className="categories-list-item-new">
            NEW!
          </div>
          }
        </Link>
      </li>
      {(props.item.getUrlKey() === 'm-best-sellers') &&
        <GiftsItem />
      }
    </>
  );
}

function GiftsItem() {
  return (
    <li role="menuitem" className="gifts-link-dropdown highlighted">
      <Link to="/gifts" external={true} key="gifts">
        <div className="name-container">
          <div className="gifts-icon-container"></div>
          <div className="gifts-label">Gifts</div>
        </div>
        <div className="categories-list-item-new">
          NEW!
        </div>
      </Link>
    </li>
  );
}
